import React from 'react';
import StatisticsSection from 'components/Solutions/StatisticsSection';
import { IContentWithImage } from 'utils/types';

export interface IStatisticsContainer {
  content: {
    title?: string;
    headline: string;
    description: string;
    backgroundColor: string;
    slug?: string;
    listOfContentWithImages?: IContentWithImage[];
    disclaimer: {
      disclaimer: string;
      childMarkdownRemark: {
        html: string;
      };
    };
  };
}

export const StatisticsContainer: React.FC<IStatisticsContainer> = ({
  content,
}) => {
  if (!content) {
    return null;
  }
  const {
    backgroundColor,
    slug,
    listOfContentWithImages,
    headline,
    disclaimer,
  } = content;

  return (
    <StatisticsSection
      backgroundColor={backgroundColor}
      slug={slug}
      listOfContent={listOfContentWithImages}
      headline={headline}
      disclaimer={disclaimer}
    />
  );
};

export default StatisticsContainer;
